<div class="col-sm-11 center-block">
    <div class="row">
        <div class="col-sm-12">
            <h1 tabindex="0" role="heading" aria-label="Forbidden" aria-level="1">Forbidden</h1>
            <h2 class="text-danger" tabindex="0" role="heading" aria-label="You have no rights to access the application." aria-level="2">You have no rights to access the application.</h2>
        </div>
    </div>
</div>
